import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MicOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mic_off"}/>
}
